import { gpHome } from '../../app';
import {
    AnalysisProject,
    AnalysisProjectServiceName,
    IAnalysisProjectService,
} from '../../services/analysis-contract';
import { IRouteAuthService, IRouteAuthServiceEvents } from '../../services/route-auth-service';
import analyzeListTemplate from './analyze-list.html';

class AnalyzeListComponent {

    static $inject = [AnalysisProjectServiceName, '$location', 'gpRouteAuthService'];

    projects: AnalysisProject[] = [];
    isLoading = true;
    errorMessage: string | null = null;

    private readonly authEvents: IRouteAuthServiceEvents = {
        loggedIn: () => { this.loadProjects(); },
        loggedOut: () => { this.$location.path('/login'); },
    };

    constructor(
        private readonly analysisProjectService: IAnalysisProjectService,
        private readonly $location: ng.ILocationService,
        private readonly gpRouteAuthService: IRouteAuthService,
    ) { }

    $onInit(): void {
        this.gpRouteAuthService.register(this.authEvents);
        this.loadProjects();
    }

    $onDestroy(): void {
        this.gpRouteAuthService.deregister(this.authEvents);
    }

    loadProjects(): void {
        this.isLoading = true;
        this.errorMessage = null;
        this.analysisProjectService.getProjects().then(projects => {
            this.projects = projects.sort((a, b) =>
                (b.lastModifiedUtc || '').localeCompare(a.lastModifiedUtc || ''));
            this.isLoading = false;
        }).catch(() => {
            this.errorMessage = 'Failed to load analysis projects.';
            this.isLoading = false;
        });
    }

    onFileSelected(files: FileList | null): void {
        if (!files || files.length === 0) return;
        this.uploadFile(files[0]);
    }

    onFileDrop(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer && event.dataTransfer.files.length > 0) {
            this.uploadFile(event.dataTransfer.files[0]);
        }
    }

    onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
    }

    navigateToProject(project: AnalysisProject): void {
        this.$location.path('/analyze/' + project.id);
    }

    private uploadFile(file: File): void {
        this.errorMessage = null;
        this.analysisProjectService.createProject(file).then(project => {
            this.$location.path('/analyze/' + project.id);
        }).catch(err => {
            // String rejections are user-facing — notably the credit gate's
            // credits_exhausted message, mapped at the service seam (#74).
            this.errorMessage = typeof err === 'string' ? err : 'Failed to create analysis project.';
        });
    }
}

gpHome.component('gpAnalyzeList', {
    template: analyzeListTemplate,
    controller: AnalyzeListComponent,
    bindings: {},
});
